import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faPhone } from '@fortawesome/free-solid-svg-icons';
import { logo } from '../assets';
const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Chiudi il menu quando cambia la pagina
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
      isScrolled 
        ? 'py-2 bg-light-surface shadow-md' 
        : 'py-4 bg-light-surface shadow-sm'
    }`}>
      <div className="container flex justify-between items-center">
        <div className="logo">
          <Link to="/" className="flex items-center text-primary hover:text-primary">
            <img src={logo} alt="logo" className="h-10" />
          </Link>
        </div>

        <div className={`lg:flex items-center ${
          isMenuOpen 
            ? 'fixed top-0 right-0 h-screen w-4/5 max-w-md bg-light-surface flex flex-col pt-20 shadow-lg transition-all duration-300' 
            : 'hidden lg:flex'
        }`}>
          {isMenuOpen && (
            <button 
              className="absolute top-4 right-4 text-2xl text-primary"
              onClick={toggleMenu}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
          
          <nav className="lg:block">
            <ul className={`
              ${isMenuOpen 
                ? 'flex flex-col w-full' 
                : 'flex'
              }
            `}>
              <li className={`
                ${isMenuOpen 
                  ? 'w-full text-center py-4 border-b border-light-border' 
                  : 'mx-4'
                }
              `}>
                <Link 
                  to="/" 
                  className={`
                    font-medium relative py-1 
                    ${location.pathname === '/' 
                      ? 'text-secondary after:content-[""] after:absolute after:bottom-[-3px] after:left-0 after:w-full after:h-0.5 after:bg-secondary' 
                      : 'text-light-text hover:text-secondary'
                    }
                    ${isMenuOpen ? 'block py-2 text-lg' : ''}
                  `}
                >
                  Home
                </Link>
              </li>
              <li className={`
                ${isMenuOpen 
                  ? 'w-full text-center py-4 border-b border-light-border' 
                  : 'mx-4'
                }
              `}>
                <Link 
                  to="/chi-siamo" 
                  className={`
                    font-medium relative py-1 
                    ${location.pathname === '/chi-siamo' 
                      ? 'text-secondary after:content-[""] after:absolute after:bottom-[-3px] after:left-0 after:w-full after:h-0.5 after:bg-secondary' 
                      : 'text-light-text hover:text-secondary'
                    }
                    ${isMenuOpen ? 'block py-2 text-lg' : ''}
                  `}
                >
                  Chi Siamo
                </Link>
              </li>
              <li className={`
                ${isMenuOpen 
                  ? 'w-full text-center py-4 border-b border-light-border' 
                  : 'mx-4'
                }
              `}>
                <Link 
                  to="/offerte" 
                  className={`
                    font-medium relative py-1 
                    ${location.pathname === '/offerte' 
                      ? 'text-secondary after:content-[""] after:absolute after:bottom-[-3px] after:left-0 after:w-full after:h-0.5 after:bg-secondary' 
                      : 'text-light-text hover:text-secondary'
                    }
                    ${isMenuOpen ? 'block py-2 text-lg' : ''}
                  `}
                >
                  Offerte
                </Link>
              </li>
              <li className={`
                ${isMenuOpen 
                  ? 'w-full text-center py-4 border-b border-light-border' 
                  : 'mx-4'
                }
              `}>
                <Link 
                  to="/contattaci" 
                  className={`
                    font-medium relative py-1 
                    ${location.pathname === '/contattaci' 
                      ? 'text-secondary after:content-[""] after:absolute after:bottom-[-3px] after:left-0 after:w-full after:h-0.5 after:bg-secondary' 
                      : 'text-light-text hover:text-secondary'
                    }
                    ${isMenuOpen ? 'block py-2 text-lg' : ''}
                  `}
                >
                  Contattaci
                </Link>
              </li>
            </ul>
          </nav>

          <div className={`${isMenuOpen ? 'mt-8 flex flex-col items-center gap-4' : 'flex items-center ml-6'}`}>
            <a href="tel:+390240055045" className="btn btn-cta">
              <FontAwesomeIcon icon={faPhone} className="mr-2" /> Consulenza Gratuita
            </a>
          </div>
        </div>

        <div className="flex items-center">
          <button 
            className="lg:hidden bg-transparent border-none text-primary text-2xl cursor-pointer" 
            onClick={toggleMenu}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header; 